<template>
  <a-popover
    overlayClassName="myPopClass"
    v-model="visible"
    title=""
    trigger="click"
    placement="bottomRight"
    :overlayStyle="popoverStyle">
    <template slot="content">
      <div class="popTitle">
        <span class="marignBottom_12">{{ title }}</span>
      </div>
      <div class="process">
        <a href="javascript:;" @click.stop="" class="marignBottom_12" v-for="item in process" @click="initiateTheProcess(item)">{{ item }}</a>
      </div>
    </template>
    <a-button type="primary" class="btnMarginLeft_12 processBtn">
      <process-icon class="icon"/>
    </a-button>
  </a-popover>
</template>

<script>
import processIcon from '@/views/equipmentLedger/modules/processIcon'
export default {
  name: 'PopDiv',
  components: { processIcon },
  props: ['title', 'popoverStyle', 'process'],
  data () {
    return {
      visible: false
    }
  },
  methods: {
    initiateTheProcess (item) {
      this.$emit('initiateTheProcess', item)
    }
  }
}
</script>

<style lang="less">
.processBtn {
  position: relative;
  .icon {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
.myPopClass {
  :global {
    .popTitle {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 32px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      border-bottom: 1px solid #e8e8e8;
    }
    .process {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px 16px;
      a {
        line-height: 15px;
      }
      .marignBottom_12 {
        margin-bottom: 12px;
      }
      a:last-child {
        margin-bottom: 0;
      }
    }
    .ant-popover-inner-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0;
    }
  }
}
</style>
